import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getOrganizationalUnitTemplatesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/organizational-unit-templates")({
    loader: async ({context}) => {
        const organizationalUnitTemplatesResult = await getOrganizationalUnitTemplatesWithCaching({
            workspaceId: context.workspace.id,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            queryClient: context.queryClient,
        });
        if (organizationalUnitTemplatesResult.success !== true) {
            throw new Error("Failed to fetch organizational unit templates");
        }

        const organizationalUnitTemplates = organizationalUnitTemplatesResult.data;

        return {
            organizationalUnitTemplates: organizationalUnitTemplates,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
